
import LoadingAnimation from '../../components/LoadingAnimation/LoadingAnimation';

export default function Loading( props) {
  return <LoadingAnimation />;
}
